import svg from "../assets/images/pattern/circle-footer-1.svg";
import patternsvg1 from "../assets/images/pattern/pattern1.svg";
import patternsvg2 from "../assets/images/pattern/pattern1.svg";
import circlebig from "../assets/images/pattern/circle-big.svg";
import circlebig2 from "../assets/images/pattern/circle-2.svg";

export const IMAGES = {
  partner1: require("../assets/images/partners/vpsl.webp"),
  partner2: require("../assets/images/partners/crc-north-keilor.webp"),

  qualification1: require("../assets/images/qualifications/arneuro.webp"),
  qualification2: require("../assets/images/qualifications/asca.webp"),
  qualification3: require("../assets/images/qualifications/uefa.webp"),

  BgImage1: require("../assets/images/background/bg1.png"),
  BgImage2: require("../assets/images/background/bg2.png"),
  BgImage3: require("../assets/images/background/bg3.png"),
  BgImage7: require("../assets/images/background/bg7.png"),
  BgImage8: require("../assets/images/background/bg-8.png"),
  BgImage9: require("../assets/images/background/bg9.png"),
  BgImage10: require("../assets/images/background/bg10.png"),
  BgImage12: require("../assets/images/background/bg12.png"),
  BgImage13: require("../assets/images/background/bg13.png"),
  BgBanner2: require("../assets/images/banner/bg2.png"),
  BgAppoint: require("../assets/images/background/bg-appointment.jpg"),
  BackgroundBg1: require("../assets/images/background/bg1.jpg"),
  BackgroundBg15: require("../assets/images/background/bg15.png"),
  SliderBg1: require("../assets/images/main-slider/slider1/bg1.jpg"),
  SliderBg2: require("../assets/images/main-slider/slider2/bg3.png"),
  Slide2Hero: require("../assets/images/main-slider/slider2/hero.png"),
  Slide2Video: require("../assets/images/main-slider/slider2/video.jpg"),
  Slide2Starts: require("../assets/images/main-slider/slider2/stars.png"),

  //logo
  logo: require("../assets/images/logo/logo.webp"),
  logoHorizontal: require("../assets/images/logo/logoPHhorizontal.webp"),
  logo1: require("../assets/images/logo/logo1.png"),
  logo2: require("../assets/images/logo/logo2.png"),
  logo3: require("../assets/images/logo/logo3.png"),
  logoWhite: require("../assets/images/logo-full-white.png"),
  logoWhite2: require("../assets/images/logo-white-2.png"),
  imgLogo2: require("../assets/images/logo-2.png"),

  boxlog3: require("../assets/images/icon-box/trophy.png"),
  academyBox: require("../assets/images/icon-box/LogoAcademy.png"),
  boxRocket: require("../assets/images/icon-box/performance.png"),
  boxFootball: require("../assets/images/icon-box/soccer.png"),
  boxAthlete: require("../assets/images/icon-box/online.png"),
  boxTraining: require("../assets/images/icon-box/semiprivate.png"),
  boxAnalisys: require("../assets/images/icon-box/game.png"),
  boxConsultancy: require("../assets/images/icon-box/head.png"),

  aboutlogo1: require("../assets/images/optimizing-photos/respect.png"),
  aboutlogo2: require("../assets/images/optimizing-photos/star.png"),
  aboutlogo3: require("../assets/images/optimizing-photos/goals.png"),
  aboutlogo4: require("../assets/images/optimizing-photos/perseverance.png"),

  services1: require("../assets/images/services/pic1.jpg"),
  services2: require("../assets/images/services/pic2.jpg"),
  services3: require("../assets/images/services/pic3.jpg"),
  services4: require("../assets/images/services/pic4.jpg"),


  aboutgirl: require("../assets/images/about/girl.png"),
  aboutman: require("../assets/images/about/man.png"),
  aboutus: require("../assets/images/optimizing-photos/aboutus.webp"),
  aboutus2: require("../assets/images/optimizing-photos/aboutus2.webp"),
  sliderpic1: require("../assets/images/main-slider/slider1/pic1.png"),
  footerbg: require("../assets/images/background/footer-bg.png"),
  footergril1: require("../assets/images/footer-girl1.png"),

  footercircle: svg,
  circlesvg1: patternsvg1,
  circlesvg2: patternsvg2,

  watning: require("../assets/images/warning.png"),

  gusBeri: require("../assets/images/optimizing-photos/gus-beri.webp"),
  claudioAltieri: require("../assets/images/optimizing-photos/claudio-profile.webp"),
  marcosReati: require("../assets/images/optimizing-photos/marcos-reati.webp"),
  lucasVaz: require("../assets/images/optimizing-photos/lucas-vaz.webp"),
  jaydenTran: require("../assets/images/optimizing-photos/jayden.webp"),
  team5: require("../assets/images/team/member5.png"),
  team6: require("../assets/images/team/member6.png"),

  portfolio1: require("../assets/images/portfolio/pic1.jpg"),
  portfolio2: require("../assets/images/portfolio/pic2.jpg"),
  portfolio3: require("../assets/images/portfolio/pic3.jpg"),
  portfolio4: require("../assets/images/portfolio/pic4.jpg"),
  portfolio5: require("../assets/images/portfolio/pic5.jpg"),
  portfolio6: require("../assets/images/portfolio/pic6.jpg"),
  portfolio7: require("../assets/images/portfolio/pic7.jpg"),

  pillars1: require("../assets/images/optimizing-photos/strength-development-2.webp"),
  pillars2: require("../assets/images/optimizing-photos/pillars2.webp"),
  pillarsSkills: require("../assets/images/optimizing-photos/pillars-skills.webp"),
  pillars3: require("../assets/images/optimizing-photos/pillars3.webp"),
  pillars4: require("../assets/images/optimizing-photos/pillars4.webp"),
  service1: require("../assets/images/optimizing-photos/service1.webp"),
  football_academy: require("../assets/images/optimizing-photos/logo_academy.webp"),
  service2: require("../assets/images/optimizing-photos/service2.webp"),
  service3: require("../assets/images/optimizing-photos/service3.webp"),
  service4: require("../assets/images/optimizing-photos/service4.webp"),
  service5: require("../assets/images/optimizing-photos/service5.webp"),
  service6: require("../assets/images/optimizing-photos/service6.webp"),
  service7: require("../assets/images/optimizing-photos/service7.webp"),
  pillarsStrength: require("../assets/images/optimizing-photos/pillars-strength.webp"),

  serviceAthleteOnlineProgramming: require("../assets/images/optimizing-photos/service-athelete-online-programming.webp"),
  serviceSportsConsultancy: require("../assets/images/optimizing-photos/service-team-sports-science-consultancy.webp"),



  bloggrid5: require("../assets/images/blog/blog-grid/pic5.jpg"),
  bloggrid6: require("../assets/images/blog/blog-grid/pic6.jpg"),
  bloggrid7: require("../assets/images/blog/blog-grid/pic7.jpg"),
  bloggrid8: require("../assets/images/blog/blog-grid/pic8.jpg"),
  bloglarg1: require("../assets/images/blog/large/pic1.jpg"),
  bloglarg2: require("../assets/images/blog/large/pic2.jpg"),
  bloglarg5: require("../assets/images/blog/large/pic5.jpg"),
  bloglarg4: require("../assets/images/blog/large/pic4.jpg"),

  recentblog1: require("../assets/images/blog/recent-blog/pic1.jpg"),
  recentblog2: require("../assets/images/blog/recent-blog/pic2.jpg"),
  recentblog3: require("../assets/images/blog/recent-blog/pic3.jpg"),

  avatar1: require("../assets/images/avatar/avatar1.jpg"),
  avatar2: require("../assets/images/avatar/avatar2.jpg"),
  avatar3: require("../assets/images/avatar/avatar3.jpg"),

  avatarlarge1: require("../assets/images/avatar/large/avatar1.jpg"),
  avatarlarge2: require("../assets/images/avatar/large/avatar2.jpg"),
  avatarlarge3: require("../assets/images/avatar/large/avatar3.jpg"),

  singlepic1: require("../assets/images/portfolio/single/pic1.jpg"),
  modalpic: require("../assets/images/modal-pic.jpg"),

  //switcher
  smallpattern1: require("../assets/images/switcher/small/pattern/pt1.jpg"),
  smallpattern2: require("../assets/images/switcher/small/pattern/pt2.jpg"),
  smallpattern3: require("../assets/images/switcher/small/pattern/pt3.jpg"),
  smallpattern4: require("../assets/images/switcher/small/pattern/pt4.jpg"),
  smallpattern5: require("../assets/images/switcher/small/pattern/pt5.jpg"),
  smallpattern6: require("../assets/images/switcher/small/pattern/pt6.jpg"),
  smallpattern7: require("../assets/images/switcher/small/pattern/pt7.jpg"),

  largepattern1: require("../assets/images/switcher/large/pattern/pt1.jpg"),
  largepattern2: require("../assets/images/switcher/large/pattern/pt2.jpg"),
  largepattern3: require("../assets/images/switcher/large/pattern/pt3.jpg"),
  largepattern4: require("../assets/images/switcher/large/pattern/pt4.jpg"),
  largepattern5: require("../assets/images/switcher/large/pattern/pt5.jpg"),
  largepattern6: require("../assets/images/switcher/large/pattern/pt6.jpg"),
  largepattern7: require("../assets/images/switcher/large/pattern/pt7.jpg"),

  smallbgimg1: require("../assets/images/switcher/small/background/bg1.jpg"),
  smallbgimg2: require("../assets/images/switcher/small/background/bg2.jpg"),
  smallbgimg3: require("../assets/images/switcher/small/background/bg3.jpg"),
  smallbgimg4: require("../assets/images/switcher/small/background/bg4.jpg"),
  smallbgimg5: require("../assets/images/switcher/small/background/bg5.jpg"),
  smallbgimg6: require("../assets/images/switcher/small/background/bg6.jpg"),
  smallbgimg7: require("../assets/images/switcher/small/background/bg7.jpg"),

  largebgimg1: require("../assets/images/switcher/large/background/bg1.jpg"),
  largebgimg2: require("../assets/images/switcher/large/background/bg2.jpg"),
  largebgimg3: require("../assets/images/switcher/large/background/bg3.jpg"),
  largebgimg4: require("../assets/images/switcher/large/background/bg4.jpg"),
  largebgimg5: require("../assets/images/switcher/large/background/bg5.jpg"),
  largebgimg6: require("../assets/images/switcher/large/background/bg6.jpg"),
  largebgimg7: require("../assets/images/switcher/large/background/bg7.jpg"),

  counterPattern: require("../assets/images/pattern.png"),

  aboutPic5: require("../assets/images/about/pic5.jpg"),
  aboutPic6: require("../assets/images/about/pic6.jpg"),
  aboutPic7: require("../assets/images/about/pic7.png"),
  aboutPic: require("../assets/images/about/pic.png"),

  overlayBoxpic1: require("../assets/images/overly-box/pic1.jpg"),
  overlayBoxpic2: require("../assets/images/overly-box/pic2.jpg"),
  overlayBoxpic3: require("../assets/images/overly-box/pic3.jpg"),
  overlayBoxpic4: require("../assets/images/overly-box/pic4.jpg"),
  overlayBoxpic5: require("../assets/images/overly-box/pic5.jpg"),

  testimonialPic4: require("../assets/images/testimonials/pic4.jpg"),
  testimonialPic5: require("../assets/images/testimonials/pic5.jpg"),
  testimonialPic6: require("../assets/images/testimonials/pic6.jpg"),

  largeTestimonialPic7: require("../assets/images/testimonials/extralaarge/pic7.png"),

  avatarLargePic1: require("../assets/images/avatar/large/avatar1.jpg"),
  avatarLargePic2: require("../assets/images/avatar/large/avatar2.jpg"),
  avatarLargePic3: require("../assets/images/avatar/large/avatar3.jpg"),

  clientLogo4: require("../assets/images/client-logo/logo4.png"),
  clientLogo5: require("../assets/images/client-logo/logo5.png"),
  clientLogo6: require("../assets/images/client-logo/logo6.png"),

  mainSliderPic1: require("../assets/images/main-slider/slider3/pic1.png"),
  miniSlidePic1: require("../assets/images/main-slider/slider3/pic1.jpg"),

  beforeimg: require("../assets/images/after-before/before.jpg"),
  afterimg: require("../assets/images/after-before/after.jpg"),

  portfolioPic8: require("../assets/images/portfolio/pic8.png"),
  portfolioPic9: require("../assets/images/portfolio/pic9.png"),
  portfolioPic10: require("../assets/images/portfolio/pic10.png"),
};

export const SVGICON = {
  map: (
    <svg
      className="svg-map"
      width="232"
      height="103"
      viewBox="0 0 232 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M97.1989 29.7683L97.3329 30.5383L95.8967 30.7704L95.6815 32.3916H97.4442L99.7656 32.2199L100.966 31.1007L99.6826 30.7063L98.9767 30.0797L97.9217 28.7624L97.4442 26.8638L95.4607 27.1789L94.9115 27.847V28.5887L95.857 29.1172L97.1989 29.7683Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M95.5362 30.3967L95.6268 29.3757L94.4906 28.9907L92.8638 29.2776L91.6635 30.7836V31.7688H93.0695L95.5362 30.3967Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M61.7557 36.404L62.386 36.0926L62.5823 35.4377L63.424 35.3886L63.7638 34.8357L62.9749 34.7017L62.3068 34.7149L61.9388 35.4377H60.2251V36.1417H60.6384C60.6384 36.1417 60.6686 36.2851 60.6913 36.4814L61.7557 36.404Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M58.4039 35.4355L57.8641 35.9923L57.7886 36.6679L59.0569 36.5849L59.1569 35.9036L58.4039 35.4355Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M189.572 69.3991L185.899 69.484L185.75 67.9138L186.347 68.1176L187.789 67.9874L187.639 66.5455L183.64 66.5795L182.557 65.449L182.614 64.8469L177.471 61.2158L176.191 62.0009L183.555 69.0537L184.597 69.3255V69.7086H183.206L183.555 70.5862L192.575 70.8957L189.572 69.3991Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M195.998 61.5331L195.372 61.3312L195.079 60.1177H194.171L193.594 61.3369L192.905 61.8219L187.685 64.0545V66.2513L189.421 68.0613H193.815L194.379 66.9345L195.372 66.2268V65.7097L195.998 65.4002V61.5331Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M199.244 65.3999L196.604 66.2001L196.657 66.6606H195.998V69.5274H197.329L197.146 67.7005L198.182 68.0025V69.282L199.28 69.2254L199.244 65.3999Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M221.48 82.7574L220.754 80.4436L218.066 78.6356L217.857 75.1819L216.683 73.5984V80.1152H211.125V76.9087L210.808 76.8899L209.926 76.4803L209.845 74.7704L211.125 74.9799V73.1927L209.9 72.6133H206.505L204.055 75.348H203.072V74.4855L200.114 74.6497L195.481 78.7941L193.014 78.8356L190.272 80.3058L190.1 86.7453L188.428 87.9984V89.1308L196.427 86.9755L202.889 86.7755L205.282 90.9162L212.633 91.1143L219.716 85.8828L221.48 82.7574Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M206.252 94.1077L208.852 94.3172L210.944 93.4207L211 92.1675L208.694 91.9731L206.252 94.1077Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M231.255 88.4531L230.173 88.6191L230.145 86.7017L228.156 86.8017L227.891 89.8006L226.146 90.7348L222.905 91.082L217.715 93.9847L216.845 94.5528V95.5228L219.536 95.2058L226.138 92.0314L227.99 91.067L229.979 90.3762L232 89.4854L231.255 88.4531Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M220.691 72.2227V71.3244H219.317L219.093 68.6067L218.251 68.3047L216.683 69.1087V70.0863L217.998 69.99V72.2227H220.691Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M210.842 67.0516L209.164 67.0931L209.304 65.7173L207.697 64.9756L205.44 66.761L206.96 68.2312L210.255 68.6067L211.125 68.9653V66.9327L210.842 67.0516Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M211 71.5263L211.125 71.5188V70.0693H210.938L211 71.5263Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M162.931 60.5461L163.565 61.8804L165.83 61.2161L166.058 59.3722L164.252 59.0967L162.931 60.5461Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M136.271 76.0672L133.182 75.7501V77.6393L134.288 78.649L133.442 79.67L132.185 80.8042V82.884L133.905 84.1844L135.45 82.2273L138.483 78.7358L139.935 73.2476H138.087L136.271 76.0672Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M199.905 70.2769H198.876V70.7034L199.667 70.8959L199.905 70.2769Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M195.387 70.896H194.171V71.4131H195.387V70.896Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M197.1 71.4128H197.842V70.9617L198.395 70.8957V70.4521H197.198L196.706 70.8957L195.998 71.4128V71.8714L197.1 71.7902V71.4128Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M200.173 71.8358H201.371V71.3432L202.2 71.4131L202.09 70.5864L200.73 70.7525L200.605 71.2866L199.078 71.4131H199.008V72.2378H200.173V71.8358Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M212.359 25.0895L214.582 24.7309L212.88 23.8004L212.942 23.0871L217.681 23.6853L218.578 23.0871L212.202 20.9771L211.168 20.9355V26.203L212.359 26.1426V25.0895Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M161.051 60.0986L162.491 60.3647L163.829 58.853H160.079L161.051 60.0986Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M178.392 60.1782L185.507 65.5362L185.879 64.5887L180.098 58.1323L180.704 56.2451L183.752 58.959L185.446 59.0949L187.685 57.9266L187.322 56.1696L183.614 53.8388L183.468 51.7212L184.523 50.6096L186.375 51.0739L186.241 52.0685L187.302 53.3632L188.249 52.8291L187.728 51.3004L192.963 49.8245L195.262 48.3204L194.9 45.6008L190.351 41.8394L190.266 38.7782H192.286L198.58 42.5415L200.358 42.1716L199.163 40.9618L195.8 39.352L196.008 36.9551L199.999 36.9627L200.32 33.9978L198.797 32.4332L199.703 31.6651L201.637 33.1976L202.27 32.5483L199.748 30.3176L193.579 29.7344L192.754 28.4378L194.539 26.4354L195.955 27.2696L200.228 27.5584L205.606 24.7388V20.7132L198.618 20.4301L191.304 24.1669V35.1735H185.752V19.0429L183.387 18.7598L180.811 18.6957L178.456 20.5622L177.473 20.5018L174.347 18.6806H165.137L160.872 16.6763L152.319 17.099L145.84 19.3921L145.879 22.0305L143.87 22.5042L143.424 19.8563L142.673 18.941L140.442 18.5032L139.918 20.0885L140.572 21.3888L132.591 20.9736L128.792 22.3532L128.213 21.0453L127.248 21.2416L126.552 22.6929L124.561 23.9178L119.697 23.8159L119.467 22.9685L124.568 22.7986L125.604 22.0947L119.467 19.8563L113.947 19.9885V22.7835L115.328 22.0229H116.283V22.9685L113.947 24.099V25.0483H113.331V25.337L115 25.9504L115.13 27.2205L112.743 29.9948L108.613 29.9646L108.351 29.3003L110.931 28.2642L110.955 25.0501H108.389V21.4775L107.802 21.7153L106.226 23.9197L103.434 24.7689L102.268 25.773L102.538 26.9299L103.978 27.0846L104.848 28.7832L107.29 28L107.72 30.2609H106.952L104.942 30.0288L102.706 30.3251L100.539 32.7257L97.4197 33.1183L96.9799 35.2018L98.301 35.4434L97.9255 36.7891L94.8247 36.3097L91.9994 36.7891L91.4106 38.0271L91.8862 40.624L93.5659 41.2355L96.3383 41.2279L98.2293 41.0864L98.8068 39.9068L101.742 36.9212L103.68 37.2288L105.577 35.8775L105.933 36.9344L110.614 39.4218L110.034 40.0239L107.926 39.9257L108.723 40.8335L110.034 41.06L111.557 40.5617L111.527 39.1142L112.216 38.85L111.655 38.3895L108.528 37.025L107.72 35.1981H110.31L111.136 35.8379L113.382 37.3609L113.463 39.1972L115.796 41.1355L116.659 38.4782L118.265 37.7818L118.563 39.9597L120.133 41.3166L124.866 41.26L126.271 42.0772V44.0268L124.549 45.2573H119.746L116.834 43.5474L113.769 43.7871V45.2573H112.784L111.74 44.6685L106.428 43.604V40.9033L99.6769 41.3148L97.5858 42.1942H94.9247L93.6036 42.0904L90.3556 43.5116V46.1707L83.7123 49.9434L84.2729 51.542H85.6109L85.2712 53.0688L84.3276 53.3519L84.2729 57.351L89.997 62.4788H92.492L92.6694 62.1617H97.1423L98.4483 61.2256H100.987L102.391 62.3278L106.182 62.6335L105.684 66.6006L109.895 72.4455L107.673 75.7728L107.83 77.3392L109.593 78.7075V82.4821L111.876 84.9035V88.0439H118.667L123.768 83.9372L125.365 81.697L126.018 81.5837H120.811V57.4756H126.365V58.6589L136.154 63.6602L141.514 57.6379L140.338 57.2L133.929 58.2607L132.266 57.6152L125.535 47.6447L126.003 47.2125L132.689 53.5783L132.857 55.5468L134.38 56.7659L137.557 56.6074L144.102 52.8725L146.17 51.8213L146.136 50.5228L143.936 50.3096C143.936 50.3096 136.239 47.4579 136.239 47.3333C136.239 47.2012 136.285 44.8912 136.285 44.8912H137.989L138.24 46.5765L141.799 48.1882L145.881 48.3411L154.699 49.4773L156.777 50.5077V52.093L156.509 54.2559L158.604 56.9547V34.7376H164.158V35.9209L175.817 41.8809L164.158 47.8429V57.4926L164.75 53.969L166.27 51.4212L168.697 50.704L172.983 51.0305L178.386 54.7937V60.1782H178.392ZM125.446 39.318V39.3105L121.554 39.1784L120.401 39.3105V37.2307L121.273 36.4588L122.207 36.2266L124.283 36.0436L124.725 35.4906L125.572 35.819L125.686 37.7176L127.952 38.4499L128.147 39.318H125.446ZM140.372 40.8014H140.365L139.676 41.3072L138.106 41.2147L137.806 40.8448L135.337 40.6938L135.511 40.0786L136.83 39.1972V38.4499L134.32 37.025L134.207 35.1981L134.718 34.3054L136.743 34.1582L138.459 34.7225L138.54 35.6661L136.081 35.5585L135.964 36.4286L139.027 38.029V39.2086L140.367 39.9653V40.8014H140.372Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M205.312 28.5544L210.255 31.7269L211.825 31.089L211.238 28.9677L210.919 28.7337L205.61 26.7256L205.312 27.0936V28.5544Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M127.409 79.4698L128.758 78.2167L131.595 75.1461L131.004 70.4939L129.798 68.8218L126.363 70.5788V81.5232L127.409 81.342V79.4698Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M68.6556 30.138L67.9743 29.8096V31.9347L68.5613 31.778L68.6556 30.138Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M67.9743 21.2282V23.3967H69.4615L70.3523 22.07L68.5613 21.717V20.9263L67.9743 21.2282Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M68.3404 35.0148C68.3404 35.0148 68.3517 35.0299 68.3517 35.0431L69.1123 34.994L69.1689 33.8654L67.9724 33.437V33.6975H64.9112L64.9999 34.2108L68.3404 35.0148Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M59.038 18.4235L56.8261 19.3257L56.9922 21.5206L54.6991 21.245L54.35 20.0353L56.5223 18.4632L52.5495 18.3084L51.3964 18.5726L50.8887 19.6352L52.3948 19.8333L52.0928 21.0129L49.5487 21.1299L49.1543 21.9056L45.442 21.9867C45.442 21.9867 45.3571 20.341 45.2118 20.341C45.0551 20.341 48.1012 20.3033 48.1012 20.3033L50.3018 18.6142L49.0996 18.1404L47.5029 19.3653L44.8513 19.2483L43.2641 17.5195H39.8689L36.317 19.6012H39.5669L39.8689 20.3486L39.0158 20.9733L42.613 21.0563L43.1622 22.0735L39.114 21.9452L38.9158 21.1658L36.3736 20.7298L35.0223 20.1485L29.0321 20.1938L27.1863 21.6017L25.9294 21.5168L24.5366 20.8846L24.0327 20.7675V25.0479H18.2349V19.9126H12.8184L8.4305 22.2604L5.48633 22.6152L4.13693 23.4399L6.22804 23.6834V24.3421H1.75329L0 25.3216L2.23832 26.8144L8.37765 26.8559L9.2307 26.1406H14.3603L16.2118 27.4353L16.0985 29.4415L17.6593 30.5739L16.3571 31.3061L16.6496 33.9483L12.0182 38.3721V42.526L14.5038 43.4716V47.1952L16.9157 50.4017L18.8426 50.6319L19.0899 49.5354L16.8138 46.7611L16.3665 44.0604H17.7159L18.2916 46.8385L21.6151 50.6376L20.7243 51.8624L22.8531 54.3989L28.0998 55.42V54.7537L30.1909 54.9802L29.9984 56.1635L31.6384 56.3881L34.1881 56.9468L37.7891 60.1589L42.3752 60.4288L42.8244 63.3767L39.6764 65.0961L39.5197 67.7137L39.0838 69.3255L43.6208 73.7927L43.9718 75.3119C43.9718 75.3119 45.6251 75.6667 45.8081 75.6667C46.0101 75.6667 49.5148 77.7503 49.5148 77.7503V85.8109L50.7604 86.0978L49.8903 89.8157L51.9909 92.0069L51.6172 95.6965L54.3764 99.5258L57.9377 101.962L61.499 102.009L61.8557 101.117L59.2399 99.3842L59.3947 98.518L59.8741 97.4517L59.976 96.3853L58.185 96.3419L57.2677 95.4644L58.7625 94.3395L58.9663 93.5053L57.313 93.143L57.4074 92.3541L59.7533 92.0823L63.324 90.7405L64.5262 89.0117L68.2687 85.2353L67.4157 82.3005L68.5612 80.7341L72.0018 80.8153L74.3137 79.3847L75.0667 73.6983L75.497 73.268H73.1002V66.8909L68.9085 66.8607L64.715 65.6113L64.5149 63.2597L63.1127 61.3328L59.3419 61.297L57.1394 58.5887L55.3465 57.9131V65.8566H49.5487V57.3054L46.5423 56.826L43.4962 59.5833L38.7176 58.9492L38.3666 54.7103L34.8619 54.2385L36.2679 52.1682L35.8641 50.9697L31.2836 53.3836L28.3942 53.1099L27.3505 51.3302L27.9903 49.492L29.5869 47.1914L33.2483 45.7306H40.3426L40.3199 47.4292L42.8753 48.3502L42.6639 45.4494L44.4984 44.0038L48.2031 42.092L48.4428 40.7539L49.5506 39.8518V38.8534H50.7755L52.1513 37.7342L56.0863 36.0319L55.7371 35.813L58.3888 33.8426L59.3721 34.0389L59.8193 34.4824L60.829 33.5954L61.0593 33.5067L59.9684 33.3897L58.8474 33.0953V32.2347L59.4324 31.8553H60.7554L61.3594 32.061L61.8727 32.8782L62.1747 32.8424V27.4731H61.9104L62.1747 25.6235V25.3518L57.9547 24.5591L56.1769 25.6065V28.8225L52.9949 29.6057L51.7059 31.7006L50.3301 31.8704V29.1962L47.3387 28.8659L45.844 28.1053L45.2382 26.3803L50.5962 23.9155L53.2138 23.289L53.4686 24.6667L54.9388 24.6082L55.0577 23.9136L56.5808 23.7438L56.5977 23.5098L55.958 23.2871L55.8013 22.5567L57.6716 22.4284L58.8021 21.5017L58.8851 21.4375V21.4451L59.2248 21.1639L62.1766 20.8732V18.1348L59.038 18.4235ZM35.5092 25.7085L32.5519 25.8575L31.9951 25.3329L34.0862 24.8611C34.0862 24.8611 35.4073 24.6761 35.5092 24.6761C35.6074 24.6742 35.5092 25.7085 35.5092 25.7085ZM35.581 22.8587L34.9468 23.4984H32.0027V22.5642V22.4774H33.3124L33.4313 22.1188H35.581V22.8587ZM40.0387 31.4382L38.5044 31.827L37.5437 30.2568L39.1102 29.6755L40.5256 29.9341L40.0387 31.4382ZM41.7543 37.9305L40.6974 37.487L40.9446 36.3169L42.3129 35.143H44.2945L41.7543 37.9305ZM46.2045 38.6005H44.2945L44.5984 37.5832L45.4986 37.5078L45.6987 37.1605L47.0689 37.0133V37.9286H47.0764L46.2045 38.6005ZM47.5237 36.0791L46.6253 36.5358L45.4967 36.6906C45.4967 36.6906 45.4967 35.2883 45.4967 35.143H47.5218L47.5237 36.0791ZM49.2279 34.9939L50.1583 35.4355L49.4129 35.913L48.7051 35.4355L49.2279 34.9939ZM48.0182 36.1697H48.1673L50.4603 36.6906V37.6134H48.5334L48.02 37.0227L48.0182 36.1697ZM46.5253 33.6332L47.7653 34.5202L46.5253 34.7561V33.6332ZM45.3665 33.2274V33.7804H45.8799V34.7561H42.277L40.9446 34.4692L41.2749 33.7804L42.9999 33.2274H45.3665Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M62.1747 24.1966V23.0869L60.3327 23.8588L62.1747 24.1966Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M66.3701 32.3686L66.5249 32.9216L67.9743 33.4387V31.9346L66.3701 32.3686Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M64.9131 33.6992L64.8546 33.369L65.8171 32.8311V32.0724L64.7923 31.8667L64.5319 32.5707L62.7012 32.8009L62.5087 32.7594V32.8084L62.1747 32.8462V33.6992H64.9131Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M113.328 24.4007L113.943 24.1025V22.7871L110.959 24.429L110.955 25.0519H113.328V24.4007Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M206.512 25.6159L205.61 24.7383V24.7402V26.7256L206.512 25.6159Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M212.142 70.0694L212.091 69.3654L211.125 68.9653V70.0694H212.142Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M163.829 58.8529H164.163V57.4922L163.96 58.7019L163.829 58.8529Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M126.363 81.5229L126.014 81.5852H126.363V81.5229Z"
        fill="var(--primary)"
        fillOpacity="0.4"
      />
      <path
        d="M211.168 26.2029L209.364 26.301V16.5683L218.712 11.7897L209.364 7.00732V6.57324H207.663V26.8257H208.318L210.919 28.7337H211.168V26.2029Z"
        fill="var(--primary)"
      />
      <path
        d="M20.2921 23.1438H22.2322V0H20.2921V0.492584L9.60815 5.95627L20.2921 11.4181V23.1438Z"
        fill="var(--primary)"
      />
      <path
        d="M66.1681 8.64746H64.2261V21.4791L63.1862 20.7808L62.1747 20.8808V23.0871L64.2261 22.2321V31.7912H66.1681V20.0674L76.8502 14.6037L66.1681 9.14382V8.64746Z"
        fill="var(--primary)"
      />
      <path
        d="M51.6002 40.8105V63.9543H53.5403V52.2305L64.2243 46.7668L53.5403 41.305V40.8105H51.6002Z"
        fill="var(--primary)"
      />
      <path
        d="M75.1516 51.5459L65.802 56.3245L75.1516 61.105V71.3643H76.8502V51.1118H75.1516V51.5459Z"
        fill="var(--primary)"
      />
      <path
        d="M110.44 23.1436H112.137V2.89111H110.44V3.32519L101.09 8.10379L110.44 12.8843V23.1436Z"
        fill="var(--primary)"
      />
      <path
        d="M214.877 58.3925V57.9565H213.176V78.209H214.877V67.9516L224.226 63.1692L214.877 58.3925Z"
        fill="var(--primary)"
      />
      <path
        d="M160.661 36.6909V56.9434H162.357V46.686L171.709 41.9074L162.357 37.125V36.6909H160.661Z"
        fill="var(--primary)"
      />
      <path
        d="M189.502 23.0098L198.854 18.2312L189.502 13.4507V13.0166H187.807V33.269H189.502V23.0098Z"
        fill="var(--primary)"
      />
      <path
        d="M122.86 59.4253V79.6777H124.557V69.4185L133.905 64.6399L124.557 59.8575V59.4253H122.86Z"
        fill="var(--primary)"
      />
    </svg>
  ),

  multilines: (
    <svg viewBox="0 0 596 803" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M300.08 326.885L5.89685 422.456V367.302L300.08 271.746V326.885Z"
        fill="url(#paint0_linear_53_55)"
      />
      <path
        d="M594.417 371.718L154.49 514.145V435.989L594.417 293.562V371.718Z"
        fill="var(--primary)"
      />
      <path
        d="M533.277 239.231L92.5232 382.16V376.355L533.277 233.426V239.231Z"
        fill="var(--primary)"
      />
      <path
        d="M592.417 134.076L151.663 277.02V271.215L592.417 128.271V134.076Z"
        fill="var(--primary)"
      />
      <path
        d="M593.356 109.22L107.549 266.762V260.365L593.356 102.823V109.22Z"
        fill="url(#paint1_linear_53_55)"
      />
      <path
        d="M587.358 216L3.2937 400.915L0.690552 388.073L584.755 203.158L587.358 216Z"
        fill="white"
      />
      <path
        d="M595 334.44L242.565 448.733L242.674 440.158L595 325.912V334.44Z"
        fill="white"
      />
      <path
        d="M585.356 284.285L45.7017 459.289V437.952L585.356 262.949V284.285Z"
        fill="var(--primary)"
      />
      <path
        d="M401.917 216.712L33.7017 336.125V321.574L401.917 202.161V216.712Z"
        fill="url(#paint2_linear_53_55)"
      />
      <path
        d="M595.356 178.583L74.377 347.532V326.927L595.356 157.993V178.583Z"
        fill="url(#paint3_linear_53_55)"
      />
      <path
        d="M593.387 233.927L142.253 380.233V358.896L593.387 212.606V233.927Z"
        fill="url(#paint4_linear_53_55)"
      />
      <path
        d="M437.55 288.331L65.4284 409.005V404.103L437.55 283.429V288.331Z"
        fill="var(--primary)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_53_55"
          x1="5.90132"
          y1="347.096"
          x2="300.081"
          y2="347.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="var(--primary-dark)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_53_55"
          x1="107.547"
          y1="184.797"
          x2="593.358"
          y2="184.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="var(--primary-dark)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_53_55"
          x1="33.7026"
          y1="269.142"
          x2="401.918"
          y2="269.142"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="var(--primary-dark)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_53_55"
          x1="74.3779"
          y1="252.758"
          x2="595.358"
          y2="252.758"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="var(--primary-dark)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_53_55"
          x1="142.26"
          y1="296.413"
          x2="593.388"
          y2="296.413"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="var(--primary-dark)" />
          <stop offset="1" stopColor="var(--primary)" />
        </linearGradient>
      </defs>
    </svg>
  ),

  circlebigSvg1: circlebig,
  circlebigSvg2: circlebig2,
  iconBox1: (
    <svg
      width="72"
      height="200"
      viewBox="0 0 72 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.43268 1.49268L69.0001 99.0571L2.00586 198.507"
        stroke="currentColor"
        strokeWidth="4"
      />
    </svg>
  ),
  iconBox2: (
    <svg
      width="72"
      height="200"
      viewBox="0 0 72 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.43268 1.49268L69.0001 99.0571L2.00586 198.507"
        stroke="currentColor"
        strokeWidth="4"
      />
    </svg>
  ),
  iconBox3: (
    <svg
      width="72"
      height="200"
      viewBox="0 0 72 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.43268 1.49268L69.0001 99.0571L2.00586 198.507"
        stroke="currentColor"
        strokeWidth="4"
      />
    </svg>
  ),
};

const appTheme = {
  IMAGES,
  SVGICON,
};

export default appTheme;
